// extracted by mini-css-extract-plugin
module.exports = {"widgets-grid":"WidgetLayout_widgets-grid__o8f3J"};